export const extractDataAttrs = (element: HTMLElement) => {
    const dataAttrs: Record<string, string> = {}
    Array.from(element.attributes).forEach(({ name, value }) => {
        if (name.startsWith('data-')) {
            dataAttrs[name.slice(5)] = value
        }
    })

    return { ...dataAttrs }
}
